<template>
  <RegionIndexPage
    :all-regions="allRegions"
    :region="region"
    :categories="categories"
    :search-keywords-of-region="searchKeywordsOfRegion"
    :history-key-words="historyKeyWords"
    :card-mode="cardMode"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { mapState } from 'pinia'
import { useABTestingStore } from '@/store-pinia/abtesting'
import notificationComposition from '@/composition/notification'

const RegionIndexPage = defineAsyncComponent(() => import('@/components/page/regions/region-index'))

export default defineNuxtComponent({
  name: 'RegionIndex',
  components: {
    RegionIndexPage,
  },
  setup() {
    definePageMeta({
      middleware: ['regions-middleware'],
    })

    const nuxtApp = useNuxtApp()
    const region = computed(() => nuxtApp.$store.getters['region/region'])

    useHead(() => {
      const pageTitle = `${region.value?.name || ''} | ${nuxtApp.$i18n.t('funnow_title')}`
      return {
        title: pageTitle,
        meta: [{ hid: 'title', name: 'title', content: pageTitle }],
      }
    })

    const { pushGiftExpiringNotification } = notificationComposition()

    return {
      pushGiftExpiringNotification,
    }
  },
  computed: {
    loggedInUser() {
      return this.$auth.user
    },
    ...mapGetters({
      allRegions: 'region/allRegions',
      region: 'region/region',
      categories: 'region/categories',
      searchKeywordsOfRegion: 'search/searchKeywordsOfRegion',
      historyKeyWords: 'search/searchKeywordsOfHistory',
    }),
    ...mapState(useABTestingStore, {
      cardMode: 'cardMode',
    }),
  },
  watch: {
    loggedInUser(newUser, oldUser) {
      if (newUser && !oldUser) {
        this.pushGiftExpiringNotification(newUser)
      }
    },
  },
  mounted() {
    this.setNotification()
  },
  beforeUnmount() {
    this.$store.dispatch('notification/resetNotification')
  },
  methods: {
    setNotification() {
      if (this.loggedInUser) {
        this.pushGiftExpiringNotification(this.loggedInUser)
      }
    },
  },
})
</script>

<style scoped lang="scss" src="@/assets/sass/pages/region-index.scss"></style>
